"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userProfileLink = exports.spotlightFeedLink = exports.postToSpotlightLink = exports.logoutLink = exports.homepageLink = exports.generateUserProfileUrl = exports.generateURL = exports.generateLensURL = exports.generateDownloadLink = exports.downloadLink = exports.cookieSettingsLink = void 0;

var _pages = require("./types/pages");

var downloadLink = "https://www.snapchat.com/download/"; // params used for tracking, issue: https://jira.sc-corp.net/browse/WEB-653

exports.downloadLink = downloadLink;
var postToSpotlightLink = "https://my.snapchat.com?utm_source=spotlight&utm_medium=post";
exports.postToSpotlightLink = postToSpotlightLink;
var userProfileLink = "https://snapchat.com/add/";
exports.userProfileLink = userProfileLink;
var cookieSettingsLink = "https://www.snapchat.com/cookie-settings";
exports.cookieSettingsLink = cookieSettingsLink;
var homepageLink = "https://www.snapchat.com/";
exports.homepageLink = homepageLink;
var spotlightFeedLink = "https://story.snapchat.com/spotlight";
exports.spotlightFeedLink = spotlightFeedLink;
var logoutLink = "https://www.snapchat.com/logout"; // TODO @cle: add page handle logout action
// The query param used with downloadLink

exports.logoutLink = logoutLink;
var sourcePageParam = "sp";

var generateURL = function generateURL(path) {
  var hostname = typeof window !== "undefined" && window.location.origin || "https://story.snapchat.com";
  return "".concat(hostname, "/").concat(path);
};

exports.generateURL = generateURL;

var generateUserProfileUrl = function generateUserProfileUrl(username) {
  var hostname = typeof window !== "undefined" && window.location.origin || "https://www.snapchat.com";

  if (hostname == "https://story.snapchat.com") {
    return "https://www.snapchat.com/add/".concat(username);
  }

  return "".concat(hostname, "/add/").concat(username);
};

exports.generateUserProfileUrl = generateUserProfileUrl;

var generateLensURL = function generateLensURL(path) {
  var hostname = typeof window !== "undefined" && window.location.origin || "https://lens.snapchat.com";
  return "".concat(hostname, "/").concat(path);
}; // Generates the link for the Snapchat download page, e.g. https://www.snapchat.com/download?sp=not_found.
// We use PageLinks.downloadUrl for the download link whenever possible. This is currently used only
// on a few pages eg, NotFound and NotAvailable where we don't populate pageLinks on the server yet.


exports.generateLensURL = generateLensURL;

var generateDownloadLink = function generateDownloadLink(pageType) {
  var sourcePage = (0, _pages.getPageTypeStringValue)(pageType).toLowerCase();
  return "".concat(downloadLink, "?").concat(sourcePageParam, "=").concat(sourcePage);
};

exports.generateDownloadLink = generateDownloadLink;